var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import Sales from './containers/Sales';
import CashDesk from './containers/CashDesk';
import TicketSales from './containers/TicketSales';
import TicketCashDesks from './containers/TicketCashDesks';
import TicketGratis from './containers/TicketGratis';
import TicketDetail from './containers/TicketDetail';
import TicketCashDeskDetail from './containers/TicketCashDeskDetail';
import TicketCanceled from './containers/TicketCanceled';
import PacketSales from './containers/PacketSales';
import PacketTicketDetail from './containers/PacketTicketDetail';
import CalendarSales from './containers/CalendarSales';
import CashdeskMovements from './containers/CashdeskMovements';
import Storage from '../../helpers/Storage';
var LAST_DATE_FROM = 'lastDateFrom';
var LAST_DATE_TO = 'lastDateTo';
var Index = /** @class */ (function (_super) {
    __extends(Index, _super);
    function Index() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Index.prototype.render = function () {
        var storageFrom = Storage.get(LAST_DATE_FROM);
        // comento para que sea el día actual. más adelante se configuro si se quiere recordar fecha seleccionada para to
        var storageTo; //  = Storage.get(LAST_DATE_TO)
        var from;
        var to;
        if (storageFrom) {
            from = new Date(storageFrom);
        }
        else {
            from = new Date();
            from.setHours(0, 0, 0, 0);
        }
        if (storageTo) {
            to = new Date(storageTo);
        }
        else {
            to = new Date();
            to.setHours(23, 59, 59, 999);
        }
        return (React.createElement(Switch, null,
            React.createElement(Route, { exact: true, path: "/sales", component: Sales }),
            React.createElement(Route, { exact: true, path: "/cashdesk", component: CashDesk }),
            React.createElement(Route, { exact: true, path: "/generalSales", render: function (props) { return React.createElement(TicketSales, __assign({}, props, { action: Action.Ticket })); } }),
            React.createElement(Route, { exact: true, path: "/operatorGeneralSales", render: function (props) { return React.createElement(TicketSales, __assign({}, props, { action: Action.Operator })); } }),
            React.createElement(Route, { exact: true, path: "/afiliteSales", render: function (props) { return React.createElement(TicketSales, __assign({}, props, { action: Action.Afiliate })); } }),
            React.createElement(Route, { exact: true, path: "/tickets", render: function (props) { return React.createElement(TicketSales, __assign({}, props, { action: Action.Ticket })); } }),
            React.createElement(Route, { exact: true, path: "/collaboratorTickets", render: function (props) { return React.createElement(TicketSales, __assign({}, props, { action: Action.Collaborator })); } }),
            React.createElement(Route, { exact: true, path: "/operatorTickets", render: function (props) { return React.createElement(TicketSales, __assign({}, props, { action: Action.Operator })); } }),
            React.createElement(Route, { exact: true, path: "/virtualTickets", render: function (props) { return React.createElement(TicketSales, __assign({}, props, { action: Action.Virtual })); } }),
            React.createElement(Route, { exact: true, path: "/ticketCashDesk", component: TicketCashDesks }),
            React.createElement(Route, { exact: true, path: "/ticketDescuento", component: TicketGratis }),
            React.createElement(Route, { exact: true, path: "/ticketCanceled", component: TicketCanceled }),
            React.createElement(Route, { exact: true, path: "/packetsales", component: PacketSales }),
            React.createElement(Route, { exact: true, path: "/tickets/:id", render: function (props) { return React.createElement(TicketDetail, __assign({}, props)); } }),
            React.createElement(Route, { exact: true, path: "/ticketCashDesk/:id", render: function (props) { return React.createElement(TicketCashDeskDetail, __assign({}, props)); } }),
            React.createElement(Route, { exact: true, path: "/packetsales/:id", component: PacketTicketDetail }),
            React.createElement(Route, { exact: true, path: "/collaboratorpacketsales/:id", render: function (props) { return React.createElement(PacketTicketDetail, __assign({}, props)); } }),
            React.createElement(Route, { exact: true, path: "/calendar", component: CalendarSales }),
            React.createElement(Route, { exact: true, path: "/cashdeskMovements", render: function (props) { return React.createElement(CashdeskMovements, __assign({ from: from, to: to }, props)); } })));
    };
    return Index;
}(Component));
export default Index;
export var Action = {
    Afiliate: 'afiliate',
    Collaborator: 'collaborator',
    Operator: 'operator',
    Ticket: 'ticket',
    Virtual: 'virtual', // tickets vendidos por virtual
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/index.tsx
// module id = 252
// module chunks = 0